<template>
  <div
    :class="listClass"
    @mouseover="$emit('showToolTip', $event, formattedValue)"
    @mouseleave="$emit('hideToolTip')"
  >
    <div v-for="(stat, index) in status" :class="getStatusClass(stat.name)" :key="index"></div>
    <div v-if="fullLength" class="statusLabel">{{ formattedValue[0] }}</div>
  </div>
</template>
<script>
import { includes, every } from 'lodash';

const isValidStatus = (status) => {
  return status && status.name && includes([
    'Approved',
    'Removed',
    'OnWatch',
    'None',
  ], status.name);
};

export default {
  name: 'statusIcons',
  props: {
    itemName: {
      type: Object,
      validator: (value) => {
        return value.singular && value.plural;
      },
      default() {
        return {
          singular: 'client',
          plural: 'clients',
        };
      },
    },
    status: {
      type: Array,
      validator: (value) => {
        return Array.isArray(value) && value.length > 0 && every(value, isValidStatus);
      },
    },
    fullLength: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listClass() {
      return `status-array-${this.status.length}`;
    },
    formattedValue() {
      const output = [];
      if (this.status.length > 1) {
        /* eslint-disable-next-line no-plusplus */
        for (let i = 0; i < this.status.length; i++) {
          let tmpstr = '';
          const stat = this.status[i];
          if (stat.name === 'OnWatch') {
            tmpstr += 'On Watch';
          } else {
            tmpstr += stat.name;
          }
          tmpstr += ` - ${stat.value}`;
          if (stat.value === 1) {
            tmpstr += ` ${this.itemName.singular}`;
          } else {
            tmpstr += ` ${this.itemName.plural}`;
          }
          output[i] = tmpstr;
        }
      } else {
        let tmpstr = '';
        if (this.status[0].name === 'OnWatch') {
          tmpstr += 'On Watch';
        } else {
          tmpstr += this.status[0].name;
        }
        output[0] = tmpstr;
      }
      return output;
    },
  },
  methods: {
    getStatusClass(value) {
      return `status-icons ${value && value.toLowerCase()}`;
    },
  },
};
</script>
<style lang="scss">
.status-array {
  &-1 {
    position: relative;
    height: 18px;
    display: flex;
    .statusLabel {
      line-height: 18px;
      padding-left: $mds-space-inset-three-quarter-x;
    }
  }
  &-2 {
    div:not(:first-child) {
      margin-left: -8px;
    }
    div:first-child {
      position: relative;
      z-index: 4;
    }
    div:nth-child(2) {
      position: relative;
      z-index: 3;
    }
  }
  &-3 {
    div:not(:first-child) {
      margin-left: -8px;
    }
    div:first-child {
      position: relative;
      z-index: 4;
    }
    div:nth-child(2) {
      position: relative;
      z-index: 3;
    }
    div:nth-child(3) {
      position: relative;
      z-index: 2;
    }
  }
  &-4 {
    div:not(:first-child) {
      margin-left: -8px;
    }
    div:first-child {
      position: relative;
      z-index: 4;
    }
    div:nth-child(2) {
      position: relative;
      z-index: 3;
    }
    div:nth-child(3) {
      position: relative;
      z-index: 2;
    }
    div:nth-child(4) {
      position: relative;
      z-index: 1;
    }
  }
}

div.status-icons {
  width: 18px;
  height: 18px;
  float: left;
  background-repeat: no-repeat;
  background-position: center center;
  &.approved {
    background-image: url("/static/assets/healthy_icon_face.svg");
  }
  &:first-child.approved {
    background-image: url("/static/assets/healthy_icon_face.svg");
  }
  &.onwatch {
    background-image: url("/static/assets/watch_icon_face.svg");
  }
  &:first-child.onwatch {
    background-image: url("/static/assets/watch_icon_face.svg");
  }
  &.removed {
    background-image: url("/static/assets/removed_icon_face.svg");
  }
  &:first-child.removed {
    background-image: url("/static/assets/removed_icon_face.svg");
  }
  &.none {
    background-image: url("/static/assets/none_icon_face.svg");
  }
  &:first-child.none {
    background-image: url("/static/assets/none_icon_face.svg");
  }
}
</style>
